export const containerNames = {
  lineContainer: 'lineContainer',
  PayTableStep1: 'PayTableStep1',
  InfoContainer: 'InfoContainer',
  ItemContainer: 'ItemContainer',
  PayOutContainer: 'payOutContainer',
  WinBarContainer: 'WinBarContainer',
  BetBarContainer: 'BetBarContainer',
  MenuBarContainer: 'MenuBarContainer',
  JackpotContainer: 'JackpotContainer',
  BoostedJackpotContainer: 'BoostedJackpotContainer',
  BoostedWheelContainer: 'BoostedWheelContainer',
  SlotBarContainer: 'SlotBarContainer',
  SpinBarContainer: 'SpinBarContainer',
  FreeBetContainer: 'FreeBetContainer',
  IconContainer: 'IconContainer',
  WinPopupContainer: 'WinPopupContainer',
  IntroBarContainer: 'IntroBarContainer',
  SettingsContainer: 'settingsContainer',
  HomeButtonWrapper: 'homeButtonWrapper',
  MobilMenuGameLogoContainer: 'mobilMenuGameLogoContainer',
  MobileViewContainer: 'mobileViewContainer',
  PayTableContainer: 'payTableContainer',
  WinSceneContainer: 'WinSceneContainer',
  WildReelsContainer: 'wildReelsContainer',
  SlotBoardContainer: 'SlotBoardContainer',
  BetButtonContainer: 'betButtonContainer',
  GameRulesContainer: 'gameRulesContainer',
  WinBarReelContainer: 'WinBarReelContainer',
  LineWinBarContainer: 'LineWinBarContainer',
  BackgroundContainer: 'BackgroundContainer',
  NotificationContainer: 'NotificationContainer',
  PopupContainer: 'PopupContainer',
  ConnectionPopup: 'connectionPopup',
  PayoutWildContainer: 'payoutWildContainer',
  MobileLogoWrapper: 'mobileLogoWrapper',
  MobileIconsWrapper: 'mobileIconsWrapper',
  FastAndSlowContainer: 'fastAndSlowContainer',
  SettingsBarContainer: 'settingsBarContainer',
  PayTableBarContainer: 'payTableBarContainer',
  PayTableArrowContainer: 'payTableArrowContainer',
  PayTableContainersWrapper: 'payTableContainersWrapper',
  SlotBarReelContainer: 'slotBarReelContainer',
  WinBarReelsContainer: 'winBarReelsContainer',
  IconsAndTextContainer: 'iconsAndTextContainer',
  MenuBarPopupContainer: 'menuBarPopupContainer',
  AutoBetPopupContainer: 'autoBetPopupContainer',
  BetBarArrowsContainer: 'betBarArrowsContainer',
  SlotBarReelsContainer: 'slotBarReelsContainer',
  ClubsJackPotContainer: 'clubsJackPotContainer',
  freeBetPopupContainer: 'freeBetPopupContainer',
  FreeSpinInfoContainer: 'freeSpinInfoContainer',
  SoundControllerWrapper: 'soundControllerWrapper',
  ExpandWildBarContainer: 'ExpandWildBarContainer',
  SoundSettingsContainer: 'soundSettingsContainer',
  HeartsJackPotContainer: 'heartsJackPotContainer',
  SpadesJackPotContainer: 'spadesJackPotContainer',
  GameRulesTextContainer: 'gameRulesTextContainer',
  WinBorderReelContainer: 'winBorderReelContainer',
  WinSymbolsBorderColumn: 'winSymbolsBorderColumn',
  PayoutSymbolsContainer: 'PayoutSymbolsContainer',
  WinAndLastWinContainer: 'winAndLastWinContainer',
  PayOutWildTextContainer: 'payOutWildTextContainer',
  WinBorderReelsContainer: 'winBorderReelsContainer',
  MenuBarWrapperContainer: 'menuBarWrapperContainer',
  SettingsHeaderContainer: 'settingsHeaderContainer',
  WinSymbolsBorderColumns: 'winSymbolsBorderColumns',
  DiamondsJackPotContainer: 'diamondsJackPotContainer',
  SettingsButtonsContainer: 'settingsButtonsContainer',
  PayTableButtonsContainer: 'payTableButtonsContainer',
  PayOutSymbolsTextContainer: 'payOutSymbolsTextContainer',
  ExpandingWildReelsContainer: 'expandingWildReelsContainer',
  DateContainer: 'dateContainer',
  GambleContainer: 'GambleContainer',
  HistoryContainer: 'historyContainer',
  AmountsContainer: 'amountsContainer',
  CollectContainer: 'collectContainer',
  WinAmountContainer: 'winAmountContainer',
  RedButtonContainer: 'redButtonContainer',
  GambleMainContainer: 'gambleMainContainer',
  AttemptsLftContainer: 'attemptsLftContainer',
  BlackButtonContainer: 'blackButtonContainer',
  GambleBackgroundContainer: 'gambleBackgroundContainer',
  GambleToWinAmountContainer: 'gambleToWinAmountContainer',
  AllLinesContainer: 'allLinesContainer',
  TextContent: 'textContent',
  PayTableOddAndAmountInfo: 'payTableOddAndAmountInfo',
  PayTableStepsContainer: 'payTableStepsContainer',
  PlayButtonContainer: 'playButtonContainer',
  AllCardsContainer: 'allCardsContainer',
  JackpotAmountInputContainer: 'jackpotAmountInputContainer',
  JackpotAmountsContainer: 'jackpotAmountsContainer',
  GameJackpotContainer: 'GameJackpotContainer',
  JackpotInfoPopupContainer: 'jackpotInfoPopupContainer',
  BoostedInfoContainer: 'BoostedInfoContainer',
  ScrollBoxContainer: 'ScrollBoxContainer',
  BackgroundPopupContainer: 'BackgroundPopupContainer',
  TitleContainer: 'TitleContainer',
  CloseButtonContainer: 'CloseButtonContainer',
  WinnersCountContainer: 'WinnersCountContainer',
  WinnersLeftCountContainer: 'WinnersLeftCountContainer',
  PrizePullContainer: 'PrizePullContainer',
  PrizePullLeftContainer: 'PrizePullLeftContainer',
  LastWinnerContainer: 'LastWinnerContainer',
  LargestWinnerContainer: 'LargestWinnerContainer',
  BlackLayerGraphicsContainer: 'BlackLayerGraphicsContainer',
  EndsInDateContainer: 'EndsInDateContainer',
  IntroTitleContainer: 'IntroTitleContainer',
  IntroItemContainer: 'IntroItemContainer',
  IntroTextsContainer: 'IntroTextsContainer',
};
